module.exports = __webpack_public_path__ + "img/logo.48027bdd.png";